import React, { createContext, PropsWithChildren, useContext } from 'react';

const Context = createContext<string | null>(null);

const combinePrefixAndSuffix = (prefix: string | null, suffix: string | null) =>
  prefix ? `${prefix}-${suffix ?? ''}` : undefined;

export const useIdPrefix = (suffix: string | null = null) => {
  const prefix = useContext(Context);
  return combinePrefixAndSuffix(prefix, suffix);
};

export const useIdPrefixAttacher = () => {
  const prefix = useContext(Context);
  return (suffix: string | null) => combinePrefixAndSuffix(prefix, suffix);
};

type IdContextProviderProps = {
  prefix: string;
};

export const IdPrefixProvider = ({ children, prefix }: PropsWithChildren<IdContextProviderProps>) => {
  return <Context.Provider value={prefix}>{children}</Context.Provider>;
};
